import React, { Suspense, useEffect, useState } from 'react';
import { Facebook as LoadingState } from 'react-content-loader';
import SectionWrapper from 'pages/Layout/SectionWrapper';
import NavigationLink from 'components/links/NavigationLink';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { useTranslation } from 'react-i18next';
import { MarginTitlePage } from './Styled';
import {
  HeaderContainer,
  VerticalSeparator,
  SubtitleHeader
} from './CreateSuggestedPostsPage/Styled';
import AdminSuggestedPosts from './AdminSuggestedPosts';
import { useHistory, useLocation } from 'react-router-dom';
import { SuccessAlert } from 'components/Alert';
import Button from 'components/buttons/Button';
import AmbassadorSuggestedPosts from './AmbassadorSuggestedPosts';
import { getSuggestedPosts } from 'services/rest/SuggestedPost/getSuggestedPosts';
import posthog from 'posthog-js';

const SuggestedPosts = () => {
  const { currentUser } = useSelector(selectUser);
  const [suggestedPosts, setSuggestedPosts] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation(['suggested_post']);
  const location = useLocation();
  const history = useHistory();
  const { state } = location as any;
  const [changeSuggestedPost, setChangeSuggestedPost] = useState<
    boolean | null
  >(false);
  const [backendSuccess, setBackendSuccess] = useState<any | null>(null);

  const showAlertSuccessChallengeCreated = async () => {
    if (typeof state === 'string') {
      setBackendSuccess(state);
    }
  };

  const getData = async () => {
    const { data } = await getSuggestedPosts(currentUser?.token, 500, 1);
    if (data) {
      console.log('suggestedPosts data', data.data.docs);
      setSuggestedPosts(data.data.docs);
    }
    showAlertSuccessChallengeCreated();
    setLoading(false);
  };

  useEffect(() => {
    if (currentUser.role === 'ambassador') {
      posthog.capture('Ingreso Propuesta de Campaña Embajador');
    } else {
      posthog.capture('Ingreso Propuesta de Campaña Admin');
    }
    getData();
  }, [changeSuggestedPost]);

  if (loading) {
    return <LoadingState height="230px" width="100%" />;
  }

  return (
    <>
      {backendSuccess && (
        <SuccessAlert
          text={backendSuccess}
          allowClose={true}
          onClose={() => setBackendSuccess(null)}
        />
      )}
      <Suspense fallback={<LoadingState height="230px" width="100%" />}>
        <SectionWrapper>
          <NavigationLink
            text={t('suggested_post:back')}
            direction="back"
            to="/dashboard"
          />
          <MarginTitlePage>
            <HeaderContainer>
              <h1>
                {currentUser.role === 'ambassador'
                  ? t('suggested_post:suggested_posts_ambassador')
                  : t('suggested_post:suggested_posts_admin')}
              </h1>
              {currentUser.role !== 'ambassador' && (
                <>
                  <VerticalSeparator />
                  <SubtitleHeader>
                    {t('suggested_post:subtitle_form_admin')}
                  </SubtitleHeader>
                </>
              )}
            </HeaderContainer>
            {currentUser.role === 'ambassador' && (
              <Button
                value={t('suggested_post:create_suggested_post_ambassador')}
                variant="primary"
                onClick={() =>
                  history.replace({ pathname: `/suggested-posts/new` })
                }
              />
            )}
          </MarginTitlePage>
          <AdminSuggestedPosts
            suggestedPosts={suggestedPosts}
            setLoading={setLoading}
            changeSuggestedPost={changeSuggestedPost}
            setChangeSuggestedPost={setChangeSuggestedPost}
            isAdmin={currentUser.role === 'admin' ? true : false}
          />
        </SectionWrapper>
      </Suspense>
    </>
  );
};

export default SuggestedPosts;
